import React, {useRef} from 'react';
import {Box, ToggleButton, ToggleButtonGroup} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ViewAgendaIcon from '@mui/icons-material/ViewAgenda';
import {useHistory, useLocation} from 'react-router-dom';
import useResizeObserver from '../../hooks/useResizeObserver';
import {EventList} from './EventsList';
import AgendaList from './AgendaList';
import Loading from '../../molcules/Loading/Loading';

export default function CalendarViews({dateControls, actions, loading = false, ...props}) {
  const ref = useRef(null);
  const dimensions = useResizeObserver(ref);
  const smallScreen = useMediaQuery('(max-width:899px)');
  const compact = dimensions?.width > 0 ? dimensions.width < 900 : smallScreen;
  const location = useLocation();
  const history = useHistory();
  const selected = new URLSearchParams(location.search).get('view');
  const view = ['calendar', 'agenda'].includes(selected) ? selected : compact ? 'agenda' : 'calendar';
  return <Box ref={ref} data-calendar-view={view} sx={{minWidth: 0, width: '100%', maxWidth: '100%'}}>
    <Box role="group" aria-label="Calendar controls" sx={{display: 'flex', flexDirection: compact ? 'column' : 'row',
      alignItems: compact ? 'flex-start' : 'center', flexWrap: 'wrap', gap: 2, py: 1,
      mt: 'clamp(0rem, calc(5.333vw - 2rem), 2rem)',
      mb: 'clamp(1rem, calc(0.8vw + 0.7rem), 1.3rem)'}}>
      <ToggleButtonGroup size="medium" exclusive value={view} aria-label="Calendar view" onChange={(_, next) => {
        if (!next) return;
        const params = new URLSearchParams(location.search);
        params.set('view', next);
        history.push({...location, search: `?${params}`});
      }} sx={{'& .MuiToggleButton-root': {height: 40, width: 40, p: 1,
        '&.Mui-selected': {color: 'primary.main', backgroundColor: '#ebf1ff',
          '&:hover': {backgroundColor: '#ebf1ff'}}}}}>
        <ToggleButton value="calendar" aria-label="Calendar" title="Calendar"><CalendarMonthIcon fontSize="small" />
        </ToggleButton>
        <ToggleButton value="agenda" aria-label="Agenda" title="Agenda"><ViewAgendaIcon fontSize="small" />
        </ToggleButton>
      </ToggleButtonGroup>
      {dateControls && <Box sx={{flex: compact ? '0 1 auto' : '0 1 480px', width: compact ? 480 : undefined,
        minWidth: 0, maxWidth: '100%'}}>{dateControls}</Box>}
      {actions && <Box sx={{display: 'flex', alignItems: 'center', flexWrap: 'wrap', justifyContent: compact ? 'flex-start' : 'flex-end', gap: 1,
        ml: compact ? 0 : 'auto', minWidth: 0, maxWidth: '100%', '& .MuiButton-root': {height: 40, textTransform: 'uppercase'}}}>
        {actions}
      </Box>}
    </Box>
    {loading ? <Loading /> : view === 'agenda' ? <AgendaList {...props} compact={compact} /> : <EventList {...props} compact={compact} />}
  </Box>;
}
